import React, { useState } from 'react';
import ScrollToTop from 'components/ScrollToTop';
import PrivacyPolicy from 'components/PrivacyPolicy';
import Sidebar from 'components/Sidebar';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer';

function PrivacyPolicyPage() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <ScrollToTop />
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <PrivacyPolicy />
      <Footer sticky />
    </>
  );
}

export default PrivacyPolicyPage;